export const countries: { code: string; name: string; flag: string }[] = [
  { code: 'Afghanistan', name: 'Afghanistan', flag: '🇦🇫' },
  { code: 'Albania', name: 'Albania', flag: '🇦🇱' },
  { code: 'Algeria', name: 'Algeria', flag: '🇩🇿' },
  { code: 'Andorra', name: 'Andorra', flag: '🇦🇩' },
  { code: 'Angola', name: 'Angola', flag: '🇦🇴' },
  { code: 'Antigua and Barbuda', name: 'Antigua and Barbuda', flag: '🇦🇬' },
  { code: 'Argentina', name: 'Argentina', flag: '🇦🇷' },
  { code: 'Armenia', name: 'Armenia', flag: '🇦🇲' },
  { code: 'Australia', name: 'Australia', flag: '🇦🇺' },
  { code: 'Austria', name: 'Austria', flag: '🇦🇹' },
  { code: 'Azerbaijan', name: 'Azerbaijan', flag: '🇦🇿' },
  { code: 'Bahamas', name: 'Bahamas', flag: '🇧🇸' },
  { code: 'Bahrain', name: 'Bahrain', flag: '🇧🇭' },
  { code: 'Bangladesh', name: 'Bangladesh', flag: '🇧🇩' },
  { code: 'Barbados', name: 'Barbados', flag: '🇧🇧' },
  { code: 'Belarus', name: 'Belarus', flag: '🇧🇾' },
  { code: 'Belgium', name: 'Belgium', flag: '🇧🇪' },
  { code: 'Belize', name: 'Belize', flag: '🇧🇿' },
  { code: 'Benin', name: 'Benin', flag: '🇧🇯' },
  { code: 'Bhutan', name: 'Bhutan', flag: '🇧🇹' },
  { code: 'Bolivia', name: 'Bolivia', flag: '🇧🇴' },
  { code: 'Bosnia and Herzegovina', name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { code: 'Botswana', name: 'Botswana', flag: '🇧🇼' },
  { code: 'Brazil', name: 'Brazil', flag: '🇧🇷' },
  { code: 'Brunei', name: 'Brunei', flag: '🇧🇳' },
  { code: 'Bulgaria', name: 'Bulgaria', flag: '🇧🇬' },
  { code: 'Burkina Faso', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'Burundi', name: 'Burundi', flag: '🇧🇮' },
  { code: 'Cambodia', name: 'Cambodia', flag: '🇰🇭' },
  { code: 'Cameroon', name: 'Cameroon', flag: '🇨🇲' },
  { code: 'Canada', name: 'Canada', flag: '🇨🇦' },
  { code: 'Cape Verde', name: 'Cape Verde', flag: '🇨🇻' },
  { code: 'Central African Republic', name: 'Central African Republic', flag: '🇨🇫' },
  { code: 'Chad', name: 'Chad', flag: '🇹🇩' },
  { code: 'Chile', name: 'Chile', flag: '🇨🇱' },
  { code: 'China', name: 'China', flag: '🇨🇳' },
  { code: 'Colombia', name: 'Colombia', flag: '🇨🇴' },
  { code: 'Comoros', name: 'Comoros', flag: '🇰🇲' },
  { code: 'Congo', name: 'Congo', flag: '🇨🇬' },
  { code: 'Costa Rica', name: 'Costa Rica', flag: '🇨🇷' },
  { code: 'Croatia', name: 'Croatia', flag: '🇭🇷' },
  { code: 'Cuba', name: 'Cuba', flag: '🇨🇺' },
  { code: 'Cyprus', name: 'Cyprus', flag: '🇨🇾' },
  { code: 'Czech Republic', name: 'Czech Republic', flag: '🇨🇿' },
  { code: 'Denmark', name: 'Denmark', flag: '🇩🇰' },
  { code: 'Djibouti', name: 'Djibouti', flag: '🇩🇯' },
  { code: 'Dominica', name: 'Dominica', flag: '🇩🇲' },
  { code: 'Dominican Republic', name: 'Dominican Republic', flag: '🇩🇴' },
  { code: 'East Timor', name: 'East Timor', flag: '🇹🇱' },
  { code: 'Ecuador', name: 'Ecuador', flag: '🇪🇨' },
  { code: 'Egypt', name: 'Egypt', flag: '🇪🇬' },
  { code: 'El Salvador', name: 'El Salvador', flag: '🇸🇻' },
  { code: 'Equatorial Guinea', name: 'Equatorial Guinea', flag: '🇬🇶' },
  { code: 'Eritrea', name: 'Eritrea', flag: '🇪🇷' },
  { code: 'Estonia', name: 'Estonia', flag: '🇪🇪' },
  { code: 'Ethiopia', name: 'Ethiopia', flag: '🇪🇹' },
  { code: 'Fiji', name: 'Fiji', flag: '🇫🇯' },
  { code: 'Finland', name: 'Finland', flag: '🇫🇮' },
  { code: 'France', name: 'France', flag: '🇫🇷' },
  { code: 'Gabon', name: 'Gabon', flag: '🇬🇦' },
  { code: 'Gambia', name: 'Gambia', flag: '🇬🇲' },
  { code: 'Georgia', name: 'Georgia', flag: '🇬🇪' },
  { code: 'Germany', name: 'Germany', flag: '🇩🇪' },
  { code: 'Ghana', name: 'Ghana', flag: '🇬🇭' },
  { code: 'Greece', name: 'Greece', flag: '🇬🇷' },
  { code: 'Grenada', name: 'Grenada', flag: '🇬🇩' },
  { code: 'Guatemala', name: 'Guatemala', flag: '🇬🇹' },
  { code: 'Guinea', name: 'Guinea', flag: '🇬🇳' },
  { code: 'Guinea-Bissau', name: 'Guinea-Bissau', flag: '🇬🇼' },
  { code: 'Guyana', name: 'Guyana', flag: '🇬🇾' },
  { code: 'Haiti', name: 'Haiti', flag: '🇭🇹' },
  { code: 'Honduras', name: 'Honduras', flag: '🇭🇳' },
  { code: 'Hungary', name: 'Hungary', flag: '🇭🇺' },
  { code: 'Iceland', name: 'Iceland', flag: '🇮🇸' },
  { code: 'India', name: 'India', flag: '🇮🇳' },
  { code: 'Indonesia', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'Iran', name: 'Iran', flag: '🇮🇷' },
  { code: 'Iraq', name: 'Iraq', flag: '🇮🇶' },
  { code: 'Ireland', name: 'Ireland', flag: '🇮🇪' },
  { code: 'Israel', name: 'Israel', flag: '🇮🇱' },
  { code: 'Italy', name: 'Italy', flag: '🇮🇹' },
  { code: 'Jamaica', name: 'Jamaica', flag: '🇯🇲' },
  { code: 'Japan', name: 'Japan', flag: '🇯🇵' },
  { code: 'Jordan', name: 'Jordan', flag: '🇯🇴' },
  { code: 'Kazakhstan', name: 'Kazakhstan', flag: '🇰🇿' },
  { code: 'Kenya', name: 'Kenya', flag: '🇰🇪' },
  { code: 'Kiribati', name: 'Kiribati', flag: '🇰🇮' },
  { code: 'Kuwait', name: 'Kuwait', flag: '🇰🇼' },
  { code: 'Kyrgyzstan', name: 'Kyrgyzstan', flag: '🇰🇬' },
  { code: 'Laos', name: 'Laos', flag: '🇱🇦' },
  { code: 'Latvia', name: 'Latvia', flag: '🇱🇻' },
  { code: 'Lebanon', name: 'Lebanon', flag: '🇱🇧' },
  { code: 'Lesotho', name: 'Lesotho', flag: '🇱🇸' },
  { code: 'Liberia', name: 'Liberia', flag: '🇱🇷' },
  { code: 'Libya', name: 'Libya', flag: '🇱🇾' },
  { code: 'Liechtenstein', name: 'Liechtenstein', flag: '🇱🇮' },
  { code: 'Lithuania', name: 'Lithuania', flag: '🇱🇹' },
  { code: 'Luxembourg', name: 'Luxembourg', flag: '🇱🇺' },
  { code: 'Madagascar', name: 'Madagascar', flag: '🇲🇬' },
  { code: 'Malawi', name: 'Malawi', flag: '🇲🇼' },
  { code: 'Malaysia', name: 'Malaysia', flag: '🇲🇾' },
  { code: 'Maldives', name: 'Maldives', flag: '🇲🇻' },
  { code: 'Mali', name: 'Mali', flag: '🇲🇱' },
  { code: 'Malta', name: 'Malta', flag: '🇲🇹' },
  { code: 'Marshall Islands', name: 'Marshall Islands', flag: '🇲🇭' },
  { code: 'Mauritania', name: 'Mauritania', flag: '🇲🇷' },
  { code: 'Mauritius', name: 'Mauritius', flag: '🇲🇺' },
  { code: 'Mexico', name: 'Mexico', flag: '🇲🇽' },
  { code: 'Micronesia', name: 'Micronesia', flag: '🇫🇲' },
  { code: 'Moldova', name: 'Moldova', flag: '🇲🇩' },
  { code: 'Monaco', name: 'Monaco', flag: '🇲🇨' },
  { code: 'Mongolia', name: 'Mongolia', flag: '🇲🇳' },
  { code: 'Montenegro', name: 'Montenegro', flag: '🇲🇪' },
  { code: 'Morocco', name: 'Morocco', flag: '🇲🇦' },
  { code: 'Mozambique', name: 'Mozambique', flag: '🇲🇿' },
  { code: 'Myanmar', name: 'Myanmar', flag: '🇲🇲' },
  { code: 'Namibia', name: 'Namibia', flag: '🇳🇦' },
  { code: 'Nauru', name: 'Nauru', flag: '🇳🇷' },
  { code: 'Nepal', name: 'Nepal', flag: '🇳🇵' },
  { code: 'Netherlands', name: 'Netherlands', flag: '🇳🇱' },
  { code: 'New Zealand', name: 'New Zealand', flag: '🇳🇿' },
  { code: 'Nicaragua', name: 'Nicaragua', flag: '🇳🇮' },
  { code: 'Niger', name: 'Niger', flag: '🇳🇪' },
  { code: 'Nigeria', name: 'Nigeria', flag: '🇳🇬' },
  { code: 'North Korea', name: 'North Korea', flag: '🇰🇵' },
  { code: 'North Macedonia', name: 'North Macedonia', flag: '🇲🇰' },
  { code: 'Norway', name: 'Norway', flag: '🇳🇴' },
  { code: 'Oman', name: 'Oman', flag: '🇴🇲' },
  { code: 'Pakistan', name: 'Pakistan', flag: '🇵🇰' },
  { code: 'Palau', name: 'Palau', flag: '🇵🇼' },
  { code: 'Palestine', name: 'Palestine', flag: '🇵🇸' },
  { code: 'Panama', name: 'Panama', flag: '🇵🇦' },
  { code: 'Papua New Guinea', name: 'Papua New Guinea', flag: '🇵🇬' },
  { code: 'Paraguay', name: 'Paraguay', flag: '🇵🇾' },
  { code: 'Peru', name: 'Peru', flag: '🇵🇪' },
  { code: 'Philippines', name: 'Philippines', flag: '🇵🇭' },
  { code: 'Poland', name: 'Poland', flag: '🇵🇱' },
  { code: 'Portugal', name: 'Portugal', flag: '🇵🇹' },
  { code: 'Qatar', name: 'Qatar', flag: '🇶🇦' },
  { code: 'Romania', name: 'Romania', flag: '🇷🇴' },
  { code: 'Russia', name: 'Russia', flag: '🇷🇺' },
  { code: 'Rwanda', name: 'Rwanda', flag: '🇷🇼' },
  { code: 'Saint Kitts and Nevis', name: 'Saint Kitts and Nevis', flag: '🇰🇳' },
  { code: 'Saint Lucia', name: 'Saint Lucia', flag: '🇱🇨' },
  { code: 'Saint Vincent and the Grenadines', name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  { code: 'Samoa', name: 'Samoa', flag: '🇼🇸' },
  { code: 'San Marino', name: 'San Marino', flag: '🇸🇲' },
  { code: 'Sao Tome and Principe', name: 'Sao Tome and Principe', flag: '🇸🇹' },
  { code: 'Saudi Arabia', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: 'Senegal', name: 'Senegal', flag: '🇸🇳' },
  { code: 'Serbia', name: 'Serbia', flag: '🇷🇸' },
  { code: 'Seychelles', name: 'Seychelles', flag: '🇸🇨' },
  { code: 'Sierra Leone', name: 'Sierra Leone', flag: '🇸🇱' },
  { code: 'Singapore', name: 'Singapore', flag: '🇸🇬' },
  { code: 'Slovakia', name: 'Slovakia', flag: '🇸🇰' },
  { code: 'Slovenia', name: 'Slovenia', flag: '🇸🇮' },
  { code: 'Solomon Islands', name: 'Solomon Islands', flag: '🇸🇧' },
  { code: 'Somalia', name: 'Somalia', flag: '🇸🇴' },
  { code: 'South Africa', name: 'South Africa', flag: '🇿🇦' },
  { code: 'South Korea', name: 'South Korea', flag: '🇰🇷' },
  { code: 'South Sudan', name: 'South Sudan', flag: '🇸🇸' },
  { code: 'Spain', name: 'Spain', flag: '🇪🇸' },
  { code: 'Sri Lanka', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: 'Sudan', name: 'Sudan', flag: '🇸🇩' },
  { code: 'Suriname', name: 'Suriname', flag: '🇸🇷' },
  { code: 'Sweden', name: 'Sweden', flag: '🇸🇪' },
  { code: 'Switzerland', name: 'Switzerland', flag: '🇨🇭' },
  { code: 'Syria', name: 'Syria', flag: '🇸🇾' },
  { code: 'Taiwan', name: 'Taiwan', flag: '🇹🇼' },
  { code: 'Tajikistan', name: 'Tajikistan', flag: '🇹🇯' },
  { code: 'Tanzania', name: 'Tanzania', flag: '🇹🇿' },
  { code: 'Thailand', name: 'Thailand', flag: '🇹🇭' },
  { code: 'Togo', name: 'Togo', flag: '🇹🇬' },
  { code: 'Tonga', name: 'Tonga', flag: '🇹🇴' },
  { code: 'Trinidad and Tobago', name: 'Trinidad and Tobago', flag: '🇹🇹' },
  { code: 'Tunisia', name: 'Tunisia', flag: '🇹🇳' },
  { code: 'Turkey', name: 'Turkey', flag: '🇹🇷' },
  { code: 'Turkmenistan', name: 'Turkmenistan', flag: '🇹🇲' },
  { code: 'Tuvalu', name: 'Tuvalu', flag: '🇹🇻' },
  { code: 'Uganda', name: 'Uganda', flag: '🇺🇬' },
  { code: 'Ukraine', name: 'Ukraine', flag: '🇺🇦' },
  { code: 'United Arab Emirates', name: 'United Arab Emirates', flag: '🇦🇪' },
  { code: 'United Kingdom', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'United States', name: 'United States', flag: '🇺🇸' },
  { code: 'Uruguay', name: 'Uruguay', flag: '🇺🇾' },
  { code: 'Uzbekistan', name: 'Uzbekistan', flag: '🇺🇿' },
  { code: 'Vanuatu', name: 'Vanuatu', flag: '🇻🇺' },
  { code: 'Vatican City', name: 'Vatican City', flag: '🇻🇦' },
  { code: 'Venezuela', name: 'Venezuela', flag: '🇻🇪' },
  { code: 'Vietnam', name: 'Vietnam', flag: '🇻🇳' },
  { code: 'Yemen', name: 'Yemen', flag: '🇾🇪' },
  { code: 'Zambia', name: 'Zambia', flag: '🇿🇲' },
  { code: 'Zimbabwe', name: 'Zimbabwe', flag: '🇿🇼' }
].sort((a, b) => {
  // Put France first
  if (a.code === 'France') return -1;
  if (b.code === 'France') return 1;
  // Then sort alphabetically
  return a.name.localeCompare(b.name);
});